import { z } from "zod";

export const contactFormSchema = z.object({
  email: z
    .string()
    .min(1, "email.required")
    .pipe(z.email("email.invalid")),
  given_name: z
    .string()
    .min(1, "name.given_name.required")
    .max(60, "name.given_name.invalid"),
  message: z
    .string()
    .max(220, "message.tooLong"),
  phone_number: z
    .string()
    .min(1, "phone_number.required")
    .max(20, "phone_number.invalid"),
  submitted_at: z
    .string(),
  family_name: z
    .string()
    .min(1, "name.family_name.required")
    .max(60, "name.family_name.invalid")
});

export type ContactFormData = z.infer<typeof contactFormSchema>;